export const SET_ACTION_TOKEN = 'SET_ACTION_TOKEN'
export const SET_DIALOG_PENDING = 'SET_DIALOG_PENDING'
export const SET_DIALOG_IS_OPEN = 'SET_DIALOG_IS_OPEN'
export const SET_DIALOG_IFRAME_URL = 'SET_DIALOG_IFRAME_URL'
export const SET_DIALOG_ERROR = 'SET_DIALOG_ERROR'
export const SET_DIALOG_SUCCESS = 'SET_DIALOG_SUCCESS'
